import SecurityPage from './SecurityPage'

export default SecurityPage
